





























































































































































































import {Component, Vue} from "vue-property-decorator";
import {Action} from "vuex-class";
import {CallDetailItemInfo} from "@/store/call/statistic/types";
import CallDetailInfoDialog from '@/components/Call/CallDetailInfoDialog.vue';
import {colorClassByStatus, formatAsJson} from "@/utils/page-utils";
import {dateFilter} from "@/utils/date-util";
import {notifyError} from "@/utils/notify-helper";
import {getTranslatedParams} from "@/utils/notify-utils";
import {ActionLog} from "@/store/auth/types";
import {MsgTransports} from "@/store/types";
import {InputWings, TextareaWings} from "wings-ui-components";

@Component({
  components: {CallDetailInfoDialog, InputWings, TextareaWings},
  filters: {dateFilter},
  methods: {colorClassByStatus, formatAsJson}
})
export default class CallDetailInfo extends Vue {
  @Action("getCallStatisticDetailInfo") actionGetStatisticDetailInfo: any;
  @Action("getCallEvents") actionGetEvents!: any;
  @Action("actionLog") actionLog: any;

  logObject: ActionLog = {};
  private transport = MsgTransports.CALL;

  defaultInfo(): CallDetailItemInfo {
    return new CallDetailItemInfo()
  }

  private messageInfo = this.defaultInfo();

  async created() {
    if (this.$route.params.id) {
      try {
        this.logObject = {
          actionPage: this.$route.meta.msgKey,
          action: "Viewing",
          actionStatus: 'success',
          objectType: "Message",
          addititionalInfo: getTranslatedParams({channel: this.transport, message_id: this.$route.params.id})
        }
        const resp = await this.actionGetStatisticDetailInfo(this.$route.params.id);
        await this.actionLog(this.logObject);
        this.messageInfo = Object.assign({}, this.messageInfo, resp.data);
      } catch(error) {
        await this.actionLog({...this.logObject, actionStatus: 'failed'})
        notifyError(error);
      }
    }
  }

  back(): void {
    this.$router.push('/report/detailed/call');
  }

  private messageContent: any = null;
  private showMessage: boolean = false;

  async showMessageContent(id: string) {
    try {
      this.messageContent = await this.actionGetEvents(id);
      this.showMessage = true
    } catch(error) {
      notifyError(error);
    }
  }

}
